import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-widget',
    targetSelector: '.module',
    name: 'widget',
    options: [
      {
        key: 'review',
        value: 'Reviews',
      },
      {
        key: 'starRating',
        value: 'Star Rating',
      },
    ],
    default_value: 'productReviews',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];

/**
 * Fera Review Atom Module
 */
export class GpTrustoo extends GpThirdParty {
  public declare $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Trustoo';
  }

  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'trustoo';
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  isAutoRenderSetting() {
    return true;
  }
}
